import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'ecoflowstream';

class EcoFlowStreamService extends ServiceBase {
    /**
     * returns power cost for device with name
     * @param {string} name - device / battery name, should be set prevent using all
     * @param {number} start - timeframe start in ems, zero for today
     * @param {number} end - timeframe end ems, may be zero, for start + 1 day
     * @returns {Promise}
     */
    getPowerCosts = (name = 'all', start = 0, end = 0) => {
        if (name === undefined) name = 'all';
        if (start === '') start = 0;
        if (end === '') end = 0;

        const url = `${baseUrl}/${service}/power/costs?name=${name}&start=${start}&end=${end}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };

    /**
     * returns power quarters for owning device see power cost RK
     * @param {string} owner - owning row key from powerCost payload, aggregated device nam + ems of day
     * @param {number} start - timeframe start ems may be zero for all slots
     * @param {number} end - timeframe end ems, may be zero, for start + 1 day
     * @param {bool} omitZero - remove zero power usages from set when true
     * @returns {Promise}
     */
    getPowerQuarters = (owner = 'all', start = 0, end = 0, omitZero = false) => {
        if (owner === undefined) owner = 'all';
        if (start === '') start = 0;
        if (end === '') end = 0;

        const url = `${baseUrl}/${service}/power/quarters?owner=${owner}&start=${start}&end=${end}&omitZero=${omitZero}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };
}

const ecoFlowStreamService = new EcoFlowStreamService();
export default ecoFlowStreamService;
